import axios from "axios";
import { authHeader } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/practitioner`;

export const listFiles = () => axios.get(`${API}/patient-files`, { headers: authHeader() }).then((r) => r.data);
export const getFile = (id) => axios.get(`${API}/patient-files/${id}`, { headers: authHeader() }).then((r) => r.data);
export const createFile = (body) => axios.post(`${API}/patient-files`, body, { headers: authHeader() }).then((r) => r.data);
export const updateFile = (id, body) => axios.put(`${API}/patient-files/${id}`, body, { headers: authHeader() }).then((r) => r.data);
export const deleteFile = (id) => axios.delete(`${API}/patient-files/${id}`, { headers: authHeader() }).then((r) => r.data);
export const getReminders = () => axios.get(`${API}/reminders`, { headers: authHeader() }).then((r) => r.data);
